import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Point_Of_Sales_Object} state
 *  @property {object} model
 *  @property {Point_Of_Sales_Properties} model.properties
 *  @property {Point_Of_Sales_Is} model.is
 *  @property {Point_Of_Sales_Has} model.has
 */
export default class PointOfSaleContact extends ObjectOverride {
	constructor(props) {
		super(props, Types.Point_Of_Sales._name);
	}

	/**
	 * @param prevProps
	 * @param {Point_Of_Sales_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		/** @type {Point_Of_Sales_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Point_Of_Sales_Properties} properties */
		let properties = this.model.properties;
		/** @type {Point_Of_Sales_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							<p className={'text-center'}>
								Enter your name and the best phone number to reach you to get more information or start the process of
								integrating<br/>
								<strong>FFL Boss</strong> with our new <strong>Point of Sale.</strong>
							</p>
							<h4 className="section-title">Request</h4>
							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"First Name"}
											value={object.name_first}
											error={object.name_first_error}
											property={properties.name_first}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Last Name"}
											value={object.name_last}
											error={object.name_last_error}
											property={properties.name_last}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									label={"Phone: 999-999-9999"}
									value={object.phone}
									error={object.phone_error}
									property={properties.phone}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
